import styled from "styled-components";

export const URLLabel = styled.div`
  font-family: Public Sans;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  color: rgb(76 79 84);
  margin: 20px 0 8px;
`;
export const URLWrapper = styled.div`
  background-color: white;
  border-radius: 6px;
  border: 1px solid #e8e8eb;
`;
